import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import Header from 'components/Header';

import ArticleList from 'modules/Media/components/ArticleList';
import MediaHeader from 'modules/Media/components/MediaHeader';
import UserArticles from 'modules/Media/components/UserArticles';
import MediaContainer from 'modules/Media/pages/MediaContainer';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  .cardHeaderRight {
    max-height: 30px;
  }

  .rightComponentsContainer {
    display: flex;
  }

  .rightComponentsContainer > :not(:last-child) {
    margin: 0 10px 0 0;
  }
`;

const MediaPage = () => (
  <MediaContainer>
    <Header title={I18n.t('media.title')} subTitle={I18n.t('media.subTitle')} />
    <MediaHeader />
    <Wrapper>
      <UserArticles />
    </Wrapper>
    <Wrapper>
      <ArticleList />
    </Wrapper>
  </MediaContainer>
);

export default MediaPage;
